import React, { useState } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Moment from 'moment';
import { groupRecipientsByCategory } from '~/helpers/Emails/recipients';

const EmailDetailsButton = ({ email, containerRef }) => {
  const { currentTeam } = Rails.helpers;
  const [showDetails, setShowDetails] = useState(false);

  if (!email) return null;

  const formatRecipient = (recipient, closePopover) => {
    const address = recipient.recipient_address;
    if (recipient.lead_id) {
      return (
        <a
          href={`/recruiter/today?lead=${recipient.lead_id}&_t=${currentTeam.id}`}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => closePopover(false)}
        >
          {address}
        </a>
      );
    }
    return address;
  };

  const renderRecipientsList = (recipients, closePopover) => recipients.map((recipient, index) => (
    <React.Fragment key={recipient.id}>
      {formatRecipient(recipient, closePopover)}
      {index < recipients.length - 1 ? ', ' : ''}
    </React.Fragment>
  ));

  const renderDetails = (closePopover) => {
    const groupedRecipients = groupRecipientsByCategory(email.email_recipients || []);

    return (
      <Popover id={`details-${email.id}`} style={{ maxWidth: '300px' }}>
        <Popover.Content className="p-2">
          <div className="text-break">
            {email.sender_name && email.sender_email && (
              <div className="row no-gutters pb-2">
                <div className="col-auto text-muted pr-1 small">From:</div>
                <div className="col text-break small">
                  {email.sender_name}
                  {' '}
                  &lt;
                  {email.sender_email}
                  &gt;
                </div>
              </div>
            )}

            {groupedRecipients.to && (
              <div className="row no-gutters pb-2">
                <div className="col-auto text-muted pr-1 small">To:</div>
                <div className="col text-break small">
                  {renderRecipientsList(groupedRecipients.to, closePopover)}
                </div>
              </div>
            )}

            {groupedRecipients.cc && (
              <div className="row no-gutters pb-2">
                <div className="col-auto text-muted pr-1 small">Cc:</div>
                <div className="col text-break small">
                  {renderRecipientsList(groupedRecipients.cc, closePopover)}
                </div>
              </div>
            )}

            {groupedRecipients.bcc && (
              <div className="row no-gutters pb-2">
                <div className="col-auto text-muted pr-1 small">Bcc:</div>
                <div className="col text-break small">
                  {renderRecipientsList(groupedRecipients.bcc, closePopover)}
                </div>
              </div>
            )}

            <div className="row no-gutters pb-2">
              <div className="col-auto text-muted pr-1 small">Date:</div>
              <div className="col small">
                {Moment(email.created_at).format('LLL')}
              </div>
            </div>

            <div className="row no-gutters">
              <div className="col-auto text-muted pr-1 small">Subject:</div>
              <div className="col text-break small">{email.subject}</div>
            </div>
          </div>
        </Popover.Content>
      </Popover>
    );
  };

  const handleToggle = (nextShow) => {
    setShowDetails(nextShow);
  };

  return (
    <OverlayTrigger
      rootClose
      trigger="click"
      placement="bottom"
      show={showDetails}
      onToggle={handleToggle}
      overlay={renderDetails(setShowDetails)}
      container={containerRef.current}
    >
      <button
        type="button"
        className="btn ml-1 p1 shadow-none d-inline-flex align-items-center justify-content-center email-details-button"
        aria-expanded={showDetails}
      >
        <FontAwesomeIcon
          icon="caret-down"
          size="sm"
        />
      </button>
    </OverlayTrigger>
  );
};

export default EmailDetailsButton;
